<template>
	<db-row class="zoom-wrapper" :class="zoomClass" valign="middle" align="center" @click="close">
		<img :id="id" />
	</db-row>
</template>

<script>
	export default {
		name: 'zoom_',
		
		props: {
			src: {
				type: String,
				default: ''
			},
			
			download: {
				type: Boolean,
				default: true
			}
		},
		
		data(){
			return {
				id: 'img_' + Math.random(),
				zoomClass: 'zoom-init'
			}
		},
		
		mounted(){
			const image = new Image(), {availWidth, availHeight} = window.screen, img = document.getElementById(this.id)
			image.src = this.src
			image.onload = () => {
				let {width, height} = image, realWidth = 0, realHeight = 0
				if(width >= height){
					realWidth = width >= availWidth ? '100%' : width + 'px'
					realHeight = 'auto'
				}else{
					realWidth = 'auto'
					realHeight = height >= availHeight ? '100%' : height + 'px'
				}
				img.src = this.src
				img.style = 'width:' + realWidth + ';height:' + realHeight
				
			}
			setTimeout(() => {
				this.zoomClass = 'zoom-active'
			}, 60)
		},
		
		methods: {
			async close(){
				return new Promise(res => {
					this.zoomClass = 'zoom-init'
					setTimeout(() => {
						this.$store.commit('mobileStore/removeDialog')
						res()
					}, 300)
				})
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.zoom-wrapper{
		position: fixed;
		z-index: 100000;
		top: 0;
		left: 0;
		background: rgba(#000, .9);
		transition: all .1s;
		color: #fff;
		padding: 100px 0;
		
		&.zoom-init{
			opacity: 0;
			transform: scale(.75);
		}
		&.zoom-active{
			opacity: 1.0;
			transform: scale(1.0);
		}
	}
</style>
